import { CanActivateFn, Router } from '@angular/router';
import { of } from "rxjs";
import { FEATURES } from "../../environments/environment";
import { inject } from '@angular/core';

export const skillFeatureGuard: CanActivateFn = (_route, _state) => {
  const router = inject(Router);
  const features = FEATURES;

  if (features.includes("skills")) {
    return of(true);
  } else {
    router.navigateByUrl("/home");
    return of(false);
  }
};